"use client"

import React from 'react';

interface SpinProps {
    children?: React.ReactNode;
}

const Spin: React.FC<SpinProps> = ({ children }) => (
    <div id="meteor">
        <div id="meteor_icon">
        </div>
    </div>
);
export default Spin;
